<go-back-button></go-back-button>
<white-card>
    <ng-container *ngIf="order && order.hasSkmsDiscrepancy; else formTemplate">
      <span>{{ 'MISSING_SKMS' | translate }} <b>{{ order.name }}</b></span>
      <ul>
        <li *ngFor="let skms of order.missingSkmsNumbers">
          {{ skms }}
        </li>
      </ul>
      <button mat-flat-button color="primary" type="button" (click)="searchMissingSKMS()">{{ 'SEARCH_MISSING_SKMS' | translate }}</button>
    </ng-container>

  <ng-template #formTemplate>
    <page-header-actions>
      <page-title labelKey="ORDER"></page-title>
      <button *ngIf="orderId" buttons mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="run()" [disabled]="!readyToRun()">
          <mat-icon class="material-icons-outlined" fontIcon="bolt"></mat-icon>
          {{ 'ORDERS.LAUNCH' | translate }}
        </button>
        <button mat-menu-item (click)="cancel()" [disabled]="canCancel()">
          <mat-icon class="material-icons-outlined" fontIcon="cancel"></mat-icon>
          {{ 'ORDERS.CANCEL' | translate }}
        </button>
      </mat-menu>
    </page-header-actions>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-row">
        <div>
          <h3>{{ 'ORDERS.STEP_1' | translate }}</h3>
          <mat-form-field>
            <mat-label>{{ 'TYPE' | translate }}</mat-label>
            <mat-select formControlName="dataType" (selectionChange)="typeChanged($event)">
              <mat-option *ngFor="let type of orderTypes" [value]="type">
                {{ ('ORDERS.TYPE.' + type) | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <ng-container *ngIf="orderType">
            <hr class="divider">
            <div class="form-row">
              <div>
                <div class="filters-header">
                  <h3>{{ 'ORDERS.STEP_2' | translate }}</h3>
                  <button *ngIf="allFilters.length" type="button" mat-button [matMenuTriggerFor]="filtersMenu"
                          [disabled]="isAddFilterDisabled()">
                    <mat-icon>add</mat-icon>
                    {{ 'ADD' | translate }}
                  </button>
                  <mat-menu #filtersMenu="matMenu">
                    <button *ngFor="let filter of availableFilters" mat-menu-item
                            (click)="addFilter(filter)">{{ filter }}
                    </button>
                  </mat-menu>
                </div>
                <ng-container *ngIf="filters.controls.length > 0; else noFilters">
                  <div formArrayName="filters" *ngFor="let filter of filters.controls; let i = index">
                    <div [formGroupName]="i" class="filter-wrapper">
                      <mat-form-field class="filter-control">
                        <mat-label>{{ filter.get('name')?.value }}</mat-label>
                        <mat-select formControlName="value">
                          <mat-option *ngFor="let value of filter.get('options')?.value" [value]="value">
                            {{ value }}
                          </mat-option>
                        </mat-select>
                        <mat-error>{{ 'FIELD_ERROR.TYPE' | translate }}</mat-error>
                      </mat-form-field>
                      <button mat-icon-button [matTooltip]="'DELETE' | translate" class="btn-filter-close"
                              (click)="removeFilter(i, filter.get('name')?.value)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                  </div>
                </ng-container>
                <ng-template #noFilters>
                  <i>{{ 'ORDERS.NO_FILTER_SELECTED' | translate }}</i>
                </ng-template>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="orderType">
            <hr class="divider">
            <h3>{{ 'ORDERS.STEP_3' | translate }}</h3>
            <mat-form-field>
              <mat-label>{{ 'ORDERS.NAME' | translate }}</mat-label>
              <input matInput formControlName="name">
              <mat-error>{{'FIELD_ERROR.NAME' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'ORDERS.PLANNED_DATE' | translate }}</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="plannedExecutionDate">
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'ORDERS.INSPECTORS' | translate }}</mat-label>
              <mat-select formControlName="users" [multiple]="true">
                <mat-option *ngFor="let user of users" [value]="user.id">
                  {{ getUserLabel(user) }}
                </mat-option>
              </mat-select>
              <mat-error>{{ 'FIELD_ERROR.INSPECTORS' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field *ngIf="showTowersControls">
              <mat-label>{{ 'ORDERS.TOWER_FORM' | translate }}</mat-label>
              <mat-select formControlName="towerForm">
                <mat-option *ngFor="let item of towerForms" [value]="item.id">
                  {{ item.name }}
                </mat-option>
              </mat-select>
              <mat-error>{{ 'FIELD_ERROR.TOWER_FORM' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field *ngIf="showSpansControls">
              <mat-label>{{ 'ORDERS.SPAN_FORM' | translate }}</mat-label>
              <mat-select formControlName="spanForm">
                <mat-option *ngFor="let item of spanForms" [value]="item.id">
                  {{ item.name }}
                </mat-option>
              </mat-select>
              <mat-error>{{ 'FIELD_ERROR.SPAN_FORM' | translate }}</mat-error>
            </mat-form-field>
          </ng-container>
          <buttons-wrapper *ngIf="orderType">
            <button mat-flat-button color="primary" type="submit">{{ 'SAVE' | translate }}</button>
          </buttons-wrapper>
        </div>
        <div>
          <ng-container *ngIf="orderType">
            <h3>{{ 'ORDERS.STEP_4' | translate }}</h3>
            <ng-container *ngIf="showTowersControls">
              <div class="data-header">{{ 'TOWERS' | translate }}</div>
              <grid-master
                *ngIf="towersColDef"
                #towersGrid
                [rowData]="towers"
                [columnDefs]="towersColDef"
                [sizeColumnsToFit]="false"
                [height]="height"
                [selectedIds]="selectedTowers"
                [lockedIds]="externalTowerIds"
              >
              </grid-master>
            </ng-container>
            <hr *ngIf="showTowersControls && showSpansControls" class="divider" />
            <ng-container *ngIf="showSpansControls">
              <div class="data-header">{{ 'SPANS' | translate }}</div>
              <grid-master
                *ngIf="spansColDef"
                #spansGrid
                [rowData]="spans"
                [columnDefs]="spansColDef"
                [sizeColumnsToFit]="false"
                [height]="height"
                [selectedIds]="selectedSpans"
                [lockedIds]="externalSpanIds"
              >
              </grid-master>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </form>
  </ng-template>
</white-card>
